import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=10fdc421"
import script from "./CategoryTable.vue?vue&type=script&lang=js"
export * from "./CategoryTable.vue?vue&type=script&lang=js"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=10fdc421&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports